import React, {
  HTMLAttributes,
  AnchorHTMLAttributes,
  ButtonHTMLAttributes
} from 'react'
import { MeshkitComponentProps } from '../types/meshkit-component-props'

export type ButtonProps = HTMLAttributes<HTMLElement> &
  MeshkitComponentProps & {
    variant?: 'primary' | 'secondary'
    stretch?: boolean
    bordered?: boolean
    leftIcon?: React.ReactNode
    rightIcon?: React.ReactNode
  } & (
    | {
        href?: never
        target?: never
        link?: false
        type?: ButtonHTMLAttributes<HTMLButtonElement>['type']
        disabled?: ButtonHTMLAttributes<HTMLButtonElement>['disabled']
      }
    | {
        link: true
        href: string
        target?: AnchorHTMLAttributes<HTMLAnchorElement>['target']
        type?: never
        disabled?: never
      }
  )

export const Button: React.FC<ButtonProps> = ({
  stretch,
  className = '',
  leftIcon,
  rightIcon,
  children,
  testId,
  variant,
  link,
  type = 'button',
  ...props
}) => {
  const Component = link ? 'a' : 'button'

  return (
    <Component
      data-testid={testId}
      className={`flex items-center justify-center body-m h-14 px-6
      rounded-[var(--button-rounded,10px)]
      ${variant === 'secondary' ? 'text-black dark:text-white' : "text-[var(--button-text,theme('colors.gray.0'))] dark:text-[var(--button-text-dark,theme('colors.gray.0'))]"}
      ${variant === 'secondary' ? 'hover:text-black dark:hover:text-white' : "hover:text-[var(--button-text-hover,theme('colors.white'))] dark:hover:text-[var(--button-text-hover-dark,theme('colors.black'))]"}
      ${variant === 'secondary' ? '' : "bg-[var(--button-primary,theme('colors.meshBlue.40'))] dark:bg-[var(--button-primary-dark,theme('colors.meshBlue.40'))]"}
      ${variant === 'secondary' ? '' : "hover:bg-[var(--button-hover,theme('colors.meshBlue.50'))] dark:hover:bg-[var(--button-hover-dark,theme('colors.meshBlue.50'))]"}
      ${variant === 'secondary' ? '' : "active:bg-[var(--button-primary,theme('colors.meshBlue.30'))] dark:active:bg-[var(--button-primary,theme('colors.meshBlue.30'))]"}
      ${variant === 'secondary' ? "border border-solid border-[var(--button-primary,theme('colors.meshBlue.40'))] dark:border-[var(--button-primary-dark,theme('colors.meshBlue.40'))]" : ''}
    disabled:bg-gray-5 dark:disabled:bg-gray-70  disabled:text-coldGray-50 dark:disabled:text-coldGray-30 ${stretch ? 'w-full' : 'w-auto'} ${className}`}
      {...(props.target === '_blank' ? { rel: 'noopener noreferrer' } : {})}
      {...props}
      type={link ? undefined : type}
    >
      {leftIcon && (
        <span className="mr-2 text-inherit fill-current">{leftIcon}</span>
      )}
      {children}
      {rightIcon && (
        <span className="ml-2 text-inherit fill-current">{rightIcon}</span>
      )}
    </Component>
  )
}
